/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from "react";
import { Alert, Form, Input } from "antd";
import MaskedInput from "antd-mask-input";

import DocumentationContext from "../../store/documentation-context";

import classes from "./contact-form.module.scss";

const ContactForm = (props) => {
  const { form, alert } = props;

  const documentationCtx = useContext(DocumentationContext);

  useEffect(() => {
    form.setFieldsValue({
      telefono: documentationCtx.telefono,
      email: documentationCtx.email,
    });
  }, []);

  return (
    <div className={classes.form}>
      <Form form={form} layout="vertical">
        {alert && 
          <Alert
              message="Advertencia"
              description="Debe completar al menos uno de los 2 campos."
              type="warning"
              showIcon
              style={{marginBottom: '20px'}}
            />
        }
        <Form.Item label="Teléfono" name="telefono">
          <MaskedInput mask="11111111111" placeholderChar=" " />
        </Form.Item>
        <Form.Item label="Email" name="email">
          <Input />
        </Form.Item>
      </Form>
    </div>
  );
};

export default ContactForm;
